export default function Spacer({
    height,
    className,
}: {
    height: string | number
    className?: string
}) {
    return <div className={className} style={{ height }}></div>
}
